// import React, { useState } from 'react';
// import {
//   Modal,
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Chip,
//   Grid,
//   Card,
//   CardContent,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem
// } from '@mui/material';

// // ✅ Correct MUI Date Pickers imports
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';


// import dayjs from 'dayjs';
// import 'dayjs/locale/en-gb';

// import EventAvailableIcon from '@mui/icons-material/EventAvailable';
// import ScheduleIcon from '@mui/icons-material/Schedule';

// const appointmentTypes = [
//   { value: 'consultation', label: '30min Consultation', duration: 30, price: 25 },
//   { value: 'deep_dive', label: '1hr Deep Dive', duration: 60, price: 50 },
//   { value: 'code_review', label: '1.5hr Code Review', duration: 90, price: 75 },
//   { value: 'full_day', label: 'Full Day Mentorship', duration: 480, price: 300 }
// ];

// export default function BookingModal({ open, onClose, expert, onBook }) {


//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [appointmentType, setAppointmentType] = useState('consultation');
//   const [timeSlot, setTimeSlot] = useState('');
//   const [notes, setNotes] = useState('');

//   const selectedType = appointmentTypes.find(t => t.value === appointmentType);

//   const availableSlots = [
//     '10:00 AM', '11:00 AM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'
//   ];
//    if (!open || !expert) return null;

//   const handleBook = () => {
//     onBook({
//       expert_id: expert.id,
//       expert_name: expert.name,
//       date: selectedDate.format('YYYY-MM-DD'),
//       time: timeSlot,
//       appointment_type: appointmentType,
//       duration: selectedType.duration,
//       price: selectedType.price,
//       notes: notes
//     });
//     onClose();
//   };

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         width: { xs: '95%', sm: 600 },
//         maxHeight: '90vh',
//         bgcolor: 'background.paper',
//         borderRadius: 4,
//         boxShadow: 24,
//         p: 4,
//         overflowY: 'auto',
//         background: 'linear-gradient(145deg, rgba(15,15,20,0.98), rgba(10,10,15,0.95))',
//         border: '1px solid rgba(43,140,255,0.3)'
//       }}>
//         <Typography variant="h5" sx={{ 
//           mb: 3, 
//           textAlign: 'center',
//           fontWeight: 700,
//           background: 'linear-gradient(90deg,#2b8cff,#6ea8ff)',
//           WebkitBackgroundClip: 'text',
//           WebkitTextFillColor: 'transparent'
//         }}>
//           📅 Book Session with {expert.name}
//         </Typography>

//         {/* Expert Summary */}
//         <Card sx={{ mb: 3, background: 'rgba(43,140,255,0.05)', border: '1px solid rgba(43,140,255,0.2)' }}>
//           <CardContent sx={{ p: 3 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//               <Box sx={{ 
//                 width: 60, height: 60, borderRadius: '50%', 
//                 background: 'linear-gradient(135deg,#2b8cff,#4da3ff)', 
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 mr: 2 
//               }}>
//                 <EventAvailableIcon sx={{ color: 'white', fontSize: 28 }} />
//               </Box>
//               <Box>
//                 <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
//                   {expert.title}
//                 </Typography>
//                 <Typography sx={{ color: '#aaa' }}>
//                   {expert.expertise?.join(', ') || 'Python/ML Expert'}
//                 </Typography>
//               </Box>
//             </Box>
//           </CardContent>
//         </Card>

//         <Grid container spacing={3}>
//           {/* Appointment Type */}
//           <Grid item xs={12}>
//             <FormControl fullWidth>
//               <InputLabel sx={{ color: '#aaa' }}>Appointment Type</InputLabel>
//               <Select
//                 value={appointmentType}
//                 onChange={(e) => setAppointmentType(e.target.value)}
//                 sx={{ 
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(43,140,255,0.5)' },
//                   '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2b8cff' }
//                 }}
//               >
//                 {appointmentTypes.map((type) => (
//                   <MenuItem key={type.value} value={type.value}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
//                       <span>{type.label}</span>
//                       <Chip label={`$${type.price}`} size="small" sx={{ background: 'rgba(0,255,127,0.2)', color: '#00ff7f' }} />
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Date & Time */}
//           <Grid item xs={12} md={6}>
//             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//               <Box components={['DateTimePicker']}>
//                 <DateTimePicker
//                   label="Select Date & Time"
//                   value={selectedDate}
//                   onChange={setSelectedDate}
//                   minDate={dayjs()}
//                   slotProps={{
//                     textField: {
//                       sx: { 
//                         '& .MuiOutlinedInput-root': { 
//                           borderRadius: '12px',
//                           background: 'rgba(12,12,18,0.8)'
//                         }
//                       }
//                     }
//                   }}
//                 />
//               </Box>
//             </LocalizationProvider>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth>
//               <InputLabel sx={{ color: '#aaa' }}>Time Slot</InputLabel>
//               <Select
//                 value={timeSlot}
//                 onChange={(e) => setTimeSlot(e.target.value)}
//                 sx={{ 
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(43,140,255,0.5)' }
//                 }}
//               >
//                 <MenuItem disabled>Available Slots</MenuItem>
//                 {availableSlots.map(slot => (
//                   <MenuItem key={slot} value={slot}>{slot}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Notes */}
//           <Grid item xs={12}>
//             <TextField
//               label="Session Notes (Optional)"
//               multiline
//               rows={3}
//               value={notes}
//               onChange={(e) => setNotes(e.target.value)}
//               fullWidth
//               placeholder="Any specific topics or questions..."
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '12px',
//                   background: 'rgba(12,12,18,0.8)',
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(43,140,255,0.5)' }
//                 }
//               }}
//             />
//           </Grid>
//         </Grid>

//         <Box sx={{ mt: 4, textAlign: 'center' }}>
//           <Typography variant="body2" sx={{ color: '#aaa', mb: 2 }}>
//             Total: <strong>${selectedType.price}</strong> • {selectedType.duration} minutes
//           </Typography>
//           <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
//             <Button
//               variant="outlined"
//               onClick={onClose}
//               sx={{ borderRadius: '12px', px: 4 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={handleBook}
//               disabled={!timeSlot}
//               sx={{
//                 borderRadius: '12px',
//                 px: 4,
//                 py: 1.5,
//                 background: 'linear-gradient(90deg,#00ff7f,#00cc66)',
//                 boxShadow: '0 4px 15px rgba(0,255,127,0.4)',
//                 fontWeight: 600,
//                 '&:hover': { background: 'linear-gradient(90deg,#00e66c,#00cc66)' }
//               }}
//             >
//               Confirm Booking
//             </Button>
//           </Box>
//         </Box>
//       </Box>
//     </Modal>
//   );
// }


// import React, { useState, useEffect } from 'react';
// import {
//   Modal, Box, Typography, Button, TextField, Chip, Grid, Card, CardContent,
//   FormControl, InputLabel, Select, MenuItem,CircularProgress
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';  // ✅ Date only
// import dayjs from 'dayjs';
// import 'dayjs/locale/en-gb';
// import EventAvailableIcon from '@mui/icons-material/EventAvailable';

// const appointmentTypes = [
//   { value: 'consultation', label: '30min Consultation', duration: 30, price: 25 },
//   { value: 'deep_dive', label: '1hr Deep Dive', duration: 60, price: 50 },
//   { value: 'code_review', label: '1.5hr Code Review', duration: 90, price: 75 },
//   { value: 'full_day', label: 'Full Day Mentorship', duration: 480, price: 300 }
// ];

// export default function BookingModal({ open, onClose, expert, onBook }) {
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [appointmentType, setAppointmentType] = useState('consultation');
//   const [timeSlot, setTimeSlot] = useState('');
//   const [notes, setNotes] = useState('');

//   // Reset form on open
//   useEffect(() => {
//     if (open && expert) {
//       setSelectedDate(dayjs());
//       setAppointmentType('consultation');
//       setTimeSlot('');
//       setNotes('');
//     }
//   }, [open, expert]);

//   const safeExpert = expert || { name: 'Expert', title: 'Senior Developer', expertise: ['Python/ML'] };
//   const selectedType = appointmentTypes.find(t => t.value === appointmentType);

//   const availableSlots = ['10:00 AM', '11:00 AM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'];

// const handleBook = async () => {
//   if (!timeSlot) return;

//   try {
//     setLoading(true);

//     // 1. Create order
//     const response = await fetch('/api/create-order/', {
//       method: 'POST',
//       headers: {
//         'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         expert_id: safeExpert.id,
//         appointment_type_id: selectedType.id,  // Add id to appointmentTypes
//         date: selectedDate.format('YYYY-MM-DD'),
//         time: timeSlot,
//         amount: selectedType.price,
//         notes: notes
//       })
//     });

//     const orderData = await response.json();

//     if (!orderData.order_id) throw new Error('Order creation failed');

//     // 2. Load Razorpay
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.onload = () => {
//       const options = {
//         key: orderData.key,
//         amount: orderData.amount,
//         currency: orderData.currency,
//         order_id: orderData.order_id,
//         name: 'Expert Booking',
//         description: `Session with ${safeExpert.name}`,
//         prefill: {
//           name: orderData.name,
//           email: orderData.email,
//           contact: orderData.contact
//         },
//         handler: async (response) => {
//           // 3. Verify payment
//           const verifyResponse = await fetch('/api/verify-payment/', {
//             method: 'POST',
//             headers: {
//               'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_signature: response.razorpay_signature,
//               booking_id: orderData.booking_id
//             })
//           });

//           const result = await verifyResponse.json();

//           if (result.success) {
//             onBookSuccess(result);  // Success callback
//             onClose();
//           }
//         },
//         theme: {
//           color: '#2b8cff'
//         }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     };
//     document.body.appendChild(script);

//   } catch (error) {
//     alert('Booking failed: ' + error.message);
//   } finally {
//     setLoading(false);
//   }
// };

// // Add loading state
// const [loading, setLoading] = useState(false);
//   if (!open) return null;

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         width: { xs: '95%', sm: 600 },
//         maxHeight: '90vh',
//         bgcolor: 'background.paper',
//         borderRadius: 4,
//         boxShadow: 24,
//         p: 4,
//         overflowY: 'auto',
//         background: 'linear-gradient(145deg, rgba(15,15,20,0.98), rgba(10,10,15,0.95))',
//         border: '1px solid rgba(43,140,255,0.3)'
//       }}>
//         {/* Header - Fixed */}
//         <Typography variant="h5" sx={{ 
//           mb: 3, textAlign: 'center', fontWeight: 700,
//           background: 'linear-gradient(90deg,#2b8cff,#6ea8ff)',
//           WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
//         }}>
//            Book Session with <strong>{safeExpert.name}</strong>
//         </Typography>

//         {/* Expert Summary - Fixed Icon */}
//         <Card sx={{ mb: 4, background: 'rgba(43,140,255,0.05)', border: '1px solid rgba(43,140,255,0.2)' }}>
//           <CardContent sx={{ p: 4 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//               <Box sx={{ 
//                 width: 70, height: 70, borderRadius: '50%', 
//                 background: 'linear-gradient(135deg,#2b8cff,#4da3ff)', 
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 mr: 3, boxShadow: '0 8px 25px rgba(43,140,255,0.4)'
//               }}>
//                 <EventAvailableIcon sx={{ color: 'white', fontSize: 35 }} />
//               </Box>
//               <Box>
//                 <Typography variant="h6" sx={{ fontWeight: 600, color: 'white', mb: 0.5 }}>
//                   {safeExpert.title || 'Senior Developer'}
//                 </Typography>
//                 <Typography sx={{ color: '#aaa', fontSize: '0.95rem' }}>
//                   {Array.isArray(safeExpert.expertise) ? safeExpert.expertise.slice(0,2).join(', ') : 'Python/ML Expert'}
//                 </Typography>
//               </Box>
//             </Box>
//           </CardContent>
//         </Card>

//         <Grid container spacing={3}>
//           {/* Appointment Type - Fixed Label Cutoff */}
//           <Grid item xs={12}>
//             <FormControl fullWidth size="medium">
//               <InputLabel sx={{ color: '#aaa', shrink: true }}>Appointment Type</InputLabel>
//               <Select
//                 value={appointmentType}
//                 onChange={(e) => setAppointmentType(e.target.value)}
//                 label="Appointment Type"
//                 MenuProps={{
//                   PaperProps: {
//                     sx: {
//                       maxHeight: 300,  // Limit height
//                       background: 'rgba(15,15,20,0.98)',
//                       border: '1px solid rgba(43,140,255,0.3)'
//                     }
//                   }
//                 }}
//                 sx={{ 
//                   minHeight: 56,
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(43,140,255,0.5)' },
//                   '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2b8cff' },
//                   '& .MuiSvgIcon-root': { color: '#2b8cff' }
//                 }}
//               >
//                 {appointmentTypes.map((type) => (
//                   <MenuItem key={type.value} value={type.value} sx={{ py: 1.5 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', py: 0.5 }}>
//                       <Typography sx={{ fontSize: '0.95rem' }}>{type.label}</Typography>
//                       <Chip 
//                         label={`$${type.price}`} 
//                         size="small" 
//                         sx={{ 
//                           background: 'rgba(0,255,127,0.2)', 
//                           color: '#00ff7f',
//                           fontWeight: 600,
//                           height: 24,
//                           fontSize: '0.8rem'
//                         }} 
//                       />
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Date Only Picker */}
//           <Grid item xs={12} md={6}>
//             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//               <DatePicker
//                 label="Select Date"
//                 value={selectedDate}
//                 onChange={setSelectedDate}
//                 minDate={dayjs()}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     size: "medium",
//                     sx: { 
//                       '& .MuiOutlinedInput-root': { 
//                         borderRadius: '12px',
//                         background: 'rgba(12,12,18,0.8)',
//                         minHeight: 56
//                       },
//                       '& .MuiInputLabel-root': { color: '#aaa' },
//                       '& .MuiSvgIcon-root': { color: '#2b8cff' }
//                     }
//                   }
//                 }}
//               />
//             </LocalizationProvider>
//           </Grid>

//           {/* Time Slot */}
//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth size="medium">
//               <InputLabel sx={{ color: '#aaa', shrink: true }}>Time Slot</InputLabel>
//               <Select
//                 value={timeSlot}
//                 onChange={(e) => setTimeSlot(e.target.value)}
//                 label="Time Slot"
//                 MenuProps={{
//                   PaperProps: {
//                     sx: {
//                       maxHeight: 250,
//                       background: 'rgba(15,15,20,0.98)',
//                       border: '1px solid rgba(43,140,255,0.3)'
//                     }
//                   }
//                 }}
//                 sx={{ 
//                   minHeight: 56,
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(43,140,255,0.5)' },
//                   '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2b8cff' },
//                   '& .MuiSvgIcon-root': { color: '#2b8cff' }
//                 }}
//               >
//                 <MenuItem disabled sx={{ opacity: 0.6 }}>
//                   Available Slots ({availableSlots.length} options)
//                 </MenuItem>
//                 {availableSlots.map(slot => (
//                   <MenuItem key={slot} value={slot} sx={{ py: 1 }}>
//                     {slot}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Notes */}
//           <Grid item xs={12}>
//             <TextField
//               label="Session Notes (Optional)"
//               multiline
//               rows={3}
//               value={notes}
//               onChange={(e) => setNotes(e.target.value)}
//               fullWidth
//               placeholder="Any specific topics, questions, or preparation notes..."
//               size="medium"
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '12px',
//                   background: 'rgba(12,12,18,0.8)',
//                   minHeight: 56,
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(43,140,255,0.5)' }
//                 },
//                 '& .MuiInputLabel-root': { color: '#aaa' }
//               }}
//             />
//           </Grid>
//         </Grid>

//         {/* Footer - Improved */}
//         <Box sx={{ mt: 5, textAlign: 'center', pt: 3, borderTop: '1px solid rgba(43,140,255,0.2)' }}>
//           <Typography variant="h6" sx={{ 
//             color: '#00ff7f', fontWeight: 700, mb: 2,
//             fontSize: { xs: '1.25rem', sm: '1.5rem' }
//           }}>
//             Total: <strong style={{ fontSize: '1.8rem' }}>${selectedType?.price || 0}</strong>
//             <span style={{ fontSize: '1rem', ml: 1, color: '#aaa' }}>• {selectedType?.duration || 0} mins</span>
//           </Typography>
//           <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
//             <Button
//               variant="outlined"
//               onClick={onClose}
//               size="large"
//               sx={{ 
//                 borderRadius: '12px', 
//                 px: 5, py: 1.5,
//                 borderColor: 'rgba(255,255,255,0.3)',
//                 color: 'rgba(255,255,255,0.9)',
//                 fontWeight: 600,
//                 fontSize: '1rem',
//                 minWidth: 140,
//                 '&:hover': { 
//                   borderColor: 'rgba(255,255,255,0.5)',
//                   background: 'rgba(255,255,255,0.05)'
//                 }
//               }}
//             >
//               Cancel
//             </Button>
//             {/* <Button
//               variant="contained"
//               onClick={handleBook}
//               disabled={!timeSlot}
//               size="large"
//               sx={{
//                 borderRadius: '12px',
//                 px: 5, py: 1.5,
//                 background: 'linear-gradient(90deg,#00ff7f,#00cc66)',
//                 boxShadow: '0 8px 25px rgba(0,255,127,0.4)',
//                 fontWeight: 700,
//                 fontSize: '1.1rem',
//                 minWidth: 180,
//                 '&:hover': { 
//                   background: 'linear-gradient(90deg,#00e66c,#00b359)',
//                   boxShadow: '0 12px 30px rgba(0,255,127,0.5)'
//                 },
//                 '&:disabled': { 
//                   background: 'rgba(0,255,127,0.3)',
//                   color: 'rgba(255,255,255,0.6)'
//                 }
//               }}
//             >
//               Confirm Booking
//             </Button> */}
//             <Button
//   variant="contained"
//   onClick={handleBook}
//   disabled={!={!timeSlot || loading}
//   size="large"
//   startIcon={
//     loading ? <CircularProgress size={18} color="inherit" /> : null
//   sx={{
//     borderRadius: '12px',
//     px: { xs: 3, sm: 5 },
//     py: { xs: 1.2, sm: 1.5 },
//     minWidth: { xs: '100%', sm: 180 },
//     width: { xs: '100%', sm: 'auto' },
//     background: loading
//       ? 'rgba(0,255,127,0.35)'
//       : 'linear-gradient(90deg,#00ff7f,#00cc66)',
//     boxShadow: loading
//       ? 'none'
//       : '0 8px 25px rgba(0,255,127,0.4)',
//     fontWeight: 700,
//     fontSize: { xs: '1rem', sm: '1.05rem' },
//     textTransform: 'none',
//     transition: 'all 0.25s ease',
//     '&:hover': {
//       background: loading
//         ? 'rgba(0,255,127,0.35)'
//         : 'linear-gradient(90deg,#00e66c,#000-0.5)',
//       boxShadow: loading
//         ? 'none'
//         : '0 12px 30px0 rgba(0,255,127,0.5)',
//       transform: loading ? 'none' : 'translateY(-1px)'
//     },
//     '&:disabled': {
//       background: 'rgba(0,255-127,0.3)',
//       color: 'rgba(255,255,255,0.65)'
//     }
//   }}
// >
//   {loading ? 'Processing Payment...' : 'Confirm Booking'}
// </Button>
//           </Box>
//         </Box>
//       </Box>
//     </Modal>
//   );
// }

// import React, { useState, useEffect } from 'react';
// import {
//   Modal, Box, Typography, Button, TextField, Chip, Grid, Card, CardContent,
//   FormControl, InputLabel, Select, MenuItem, CircularProgress
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import EventAvailableIcon from '@mui/icons-material/EventAvailable';

// // const appointmentTypes = [
// //   { id: 1, value: 'consultation', label: '30min Consultation', duration: 30, price: 500 },
// //   { id: 2, value: 'deep_dive', label: '1hr Deep Dive', duration: 60, price: 1000},
// //   { id: 3, value: 'code_review', label: '1.5hr Code Review', duration: 90, price: 1500 },
// //   { id: 4, value: 'full_day', label: 'Full Day Mentorship', duration: 480, price: 2000 }
// // ];


// export default function BookingModal({ open, onClose, expert, onBookSuccess }) {
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [appointmentType, setAppointmentType] = useState('consultation');
//   const [timeSlot, setTimeSlot] = useState('');
//   const [notes, setNotes] = useState('');
//   const [loading, setLoading] = useState(false);

// const basePrice = expert?.consultation_fee || 500;
// const appointmentTypes = [
//   { id:1,value: "30min", label: "30min", duration: 30, price: basePrice / 2 },
//   { id:2,value: "1hr", label: "1hr", duration: 60, price: basePrice },
//   { id:3,value: "1.5hr", label: "1.5hr", duration: 90, price: basePrice * 1.5 },
//   { id:4,value: "2hr", label: "2hr", duration: 120, price: basePrice * 2 },
// ];

//   useEffect(() => {
//     if (open && expert) {
//       setSelectedDate(dayjs());
//       setAppointmentType('consultation');
//       setTimeSlot('');
//       setNotes('');
//     }
//   }, [open, expert]);

//   const safeExpert = expert || {
//     name: 'Expert',
//     title: 'Senior Developer',
//     expertise: ['Python/ML']
//   };

//   const selectedType = appointmentTypes.find(t => t.value === appointmentType);
//   const [availableSlots, setAvailableSlots] = useState([]);
// const [slotsLoading, setSlotsLoading] = useState(false);

//   // const availableSlots = [
//   //   '10:00 AM', '11:00 AM', '2:00 PM',
//   //   '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'
//   // ];

//   useEffect(() => {
//   if (!expert || !selectedDate) return;

//   const fetchSlots = async () => {
//     try {
//       setSlotsLoading(true);

//       const API_URL = process.env.REACT_APP_API_URL;

//       const res = await fetch(
//         `${API_URL}/experts/${expert.id}/available-slots/`
//       );

//       const data = await res.json();

//       // 🔥 filter by selected date → day
//       const selectedDateStr = selectedDate.format("YYYY-MM-DD");

// const filtered = data.filter(
//   slot => slot.date === selectedDateStr
// );

//       // convert to UI format
//       const formatted = filtered.map(slot => slot.start_time);

//       setAvailableSlots(formatted);

//     } catch (err) {
//       console.error("Failed to load slots", err);
//     } finally {
//       setSlotsLoading(false);
//     }
//   };

//   fetchSlots();
// }, [selectedDate, expert]);

// const handleBook = async () => {
//     if (!timeSlot) return;
//     try {
//       setLoading(true);
//       const API_URL = process.env.REACT_APP_API_URL;  // ✅ add base URL

//       const response = await fetch(`${API_URL}/create-order/`, {  // ✅ fix URL
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           expert_id: safeExpert.id,
//           appointment_type_id: selectedType.id,
//           date: selectedDate.format('YYYY-MM-DD'),
//           time: timeSlot,
//           amount: selectedType.price,
//           notes: notes
//         })
//       });

//       if (!response.ok) {                              // ✅ check HTTP errors BEFORE .json()
//         const text = await response.text();            //    this is why you saw "<!DOCTYPE..."
//         throw new Error(`Server error ${response.status}: ${text}`);
//       }

//       const orderData = await response.json();
//       if (!orderData.order_id) throw new Error('Order creation failed');

//       // ✅ Bug 6 fix — load Razorpay script only once
//       const loadRazorpay = () => new Promise((resolve) => {
//         if (window.Razorpay) return resolve();         // already loaded, skip
//         const script = document.createElement('script');
//         script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//         script.onload = resolve;
//         document.body.appendChild(script);
//       });

//       await loadRazorpay();

//       const options = {
//         key: orderData.key,
//         amount: orderData.amount,
//         currency: orderData.currency,
//         order_id: orderData.order_id,
//         name: 'Expert Booking',
//         description: `Session with ${safeExpert.name}`,
//         handler: async (razorpayResponse) => {
//           const verifyRes = await fetch(`${API_URL}/verify-payment/`, {  // ✅ fix URL
//             method: 'POST',
//             headers: {
//               'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//               razorpay_payment_id: razorpayResponse.razorpay_payment_id,
//               razorpay_order_id: razorpayResponse.razorpay_order_id,
//               razorpay_signature: razorpayResponse.razorpay_signature,
//               booking_id: orderData.booking_id
//             })
//           });

//           if (!verifyRes.ok) throw new Error('Payment verification failed');
//           const result = await verifyRes.json();
//           if (result.success) {
//             onBookSuccess && onBookSuccess(result);
//             onClose();
//           }
//         },
//         theme: { color: '#2b8cff' }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();

//     } catch (error) {
//       alert('Booking failed: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//     };


//   if (!open) return null;

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         width: { xs: '95%', sm: '85%', md: 600 },
//         maxHeight: '90vh',
//         bgcolor: 'background.paper',
//         borderRadius: 4,
//         p: { xs: 2, sm: 4 },
//         overflowY: 'auto',
//         background: 'linear-gradient(145deg, rgba(15,15,20,0.98), rgba(10,10,15,0.95))',
//         border: '1px solid rgba(43,140,255,0.3)'
//       }}>

//         <Typography variant="h5" sx={{
//           mb: 3,
//           textAlign: 'center',
//           fontWeight: 700,
//           background: 'linear-gradient(90deg,#2b8cff,#6ea8ff)',
//           WebkitBackgroundClip: 'text',
//           WebkitTextFillColor: 'transparent'
//         }}>
//           Book Session with <strong>{safeExpert.name}</strong>
//         </Typography>

//         <Card sx={{ mb: 4, background: 'rgba(43,140,255,0.05)' }}>
//           <CardContent sx={{ p: 3 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <Box sx={{
//                 width: 60, height: 60, borderRadius: '50%',
//                 background: 'linear-gradient(135deg,#2b8cff,#4da3ff)',
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 mr: 2
//               }}>
//                 <EventAvailableIcon sx={{ color: 'white' }} />
//               </Box>
//               <Box>
//                 <Typography variant="h6" sx={{ color: 'white' }}>
//                   {safeExpert.title}
//                 </Typography>
//                 <Typography sx={{ color: '#aaa' }}>
//                   {safeExpert.expertise?.join(', ')}
//                 </Typography>
//               </Box>
//             </Box>
//           </CardContent>
//         </Card>

//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <FormControl fullWidth>
//               <InputLabel shrink>Appointment Type</InputLabel>
//               <Select
//                 value={appointmentType}
//                 onChange={(e) => setAppointmentType(e.target.value)}
//               >
//                 {appointmentTypes.map(type => (
//                   <MenuItem key={type.value} value={type.value}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
//                       {type.label}
//                       <Chip label={`₹${type.price}`} size="small" />
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DatePicker
//                 label="Select Date"
//                 value={selectedDate}
//                 onChange={setSelectedDate}
//                 minDate={dayjs()}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </LocalizationProvider>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth>
//               <InputLabel shrink>Time Slot</InputLabel>
//               <Select
//                 value={timeSlot}
//                 onChange={(e) => setTimeSlot(e.target.value)}
//               >
//                 {availableSlots.map(slot => (
//                   <MenuItem key={slot} value={slot}>{slot}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               label="Notes"
//               multiline
//               rows={3}
//               value={notes}
//               onChange={(e) => setNotes(e.target.value)}
//               fullWidth
//             />
//           </Grid>
//         </Grid>

//         <Box sx={{ mt: 4, textAlign: 'center' }}>
//           <Typography variant="h6" sx={{ color: '#00ff7f' }}>
//             ₹{selectedType?.price} • {selectedType?.duration} mins
//           </Typography>

//           <Box sx={{
//             display: 'flex',
//             gap: 2,
//             mt: 2,
//             flexDirection: { xs: 'column', sm: 'row' }
//           }}>
//             <Button fullWidth variant="outlined" onClick={onClose}>
//               Cancel
//             </Button>

//             <Button
//               fullWidth
//               variant="contained"
//               onClick={handleBook}
//               disabled={!timeSlot || loading}
//               startIcon={loading && <CircularProgress size={18} />}
//               sx={{
//                 background: 'linear-gradient(90deg,#00ff7f,#00cc66)',
//               }}
//             >
//               {loading ? 'Processing...' : 'Confirm Booking'}
//             </Button>
//           </Box>
//         </Box>

//       </Box>
//     </Modal>
//   );
// }

import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import {
  Modal, Box, Typography, Button, TextField, Chip, Grid,
  Card, CardContent, FormControl, InputLabel, Select,
  MenuItem, CircularProgress, Avatar
} from '@mui/material';
import dayjs from 'dayjs';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';

// ─── Design tokens ────────────────────────────────────────────────────────────
const T = {
  blue: '#4f9eff',
  blueDim: 'rgba(79,158,255,0.08)',
  blueBorder: 'rgba(79,158,255,0.2)',
  blueGlow: 'rgba(79,158,255,0.3)',
  green: '#00e676',
  greenDim: 'rgba(0,230,118,0.08)',
  greenBorder: 'rgba(0,230,118,0.22)',
  surface: 'rgba(4,5,12,0.99)',
  surfaceUp: 'rgba(8,10,20,0.98)',
  card: 'rgba(11,13,24,0.95)',
  border: 'rgba(255,255,255,0.04)',
  text: '#c8d0e8',
  textSub: '#6e7a96',
  textMuted: '#3e4658',
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const fmtDay = (d) => dayjs(d).format('ddd');         // Mon
const fmtDate = (d) => dayjs(d).format('D');           // 14
const fmtMonth = (d) => dayjs(d).format('MMM');         // Apr
const fmtTime = (t) => {                               // "14:00:00" → "2:00 PM"
  const [h, m] = t.split(':');
  const hour = parseInt(h, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const h12 = hour % 12 || 12;
  return `${h12}:${m} ${ampm}`;
};

// ─── Subcomponents ────────────────────────────────────────────────────────────

function SectionLabel({ icon, children }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
      {React.cloneElement(icon, { sx: { fontSize: 15, color: T.blue } })}
      <Typography sx={{ fontSize: '0.72rem', color: '#9fb4ff', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
        {children}
      </Typography>
    </Box>
  );
}

function DateChip({ date, selected, onClick, slotCount }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        px: 1.5, py: 1.4,
        minWidth: 58,
        borderRadius: '14px',
        cursor: 'pointer',
        border: `1px solid ${selected ? T.blue : T.border}`,
        background: selected ? T.blueDim : 'rgba(255,255,255,0.025)',
        boxShadow: selected ? `0 0 0 1px ${T.blueBorder}, 0 4px 16px ${T.blueDim}` : 'none',
        transition: 'all 0.18s ease',
        '&:hover': {
          border: `1px solid ${T.blueBorder}`,
          background: T.blueDim,
          transform: 'translateY(-2px)',
        },
        '&:active': { transform: 'scale(0.97)' },
      }}
    >
      <Typography sx={{ fontSize: '0.65rem', color: selected ? T.blue : T.textMuted, fontWeight: 600, lineHeight: 1, mb: 0.4 }}>
        {fmtDay(date)}
      </Typography>
      <Typography sx={{ fontSize: '1.05rem', color: selected ? T.blue : T.text, fontWeight: 700, lineHeight: 1 }}>
        {fmtDate(date)}
      </Typography>
      <Typography sx={{ fontSize: '0.62rem', color: selected ? T.blue : T.textMuted, lineHeight: 1, mt: 0.4 }}>
        {fmtMonth(date)}
      </Typography>
      <Box sx={{
        mt: 0.8, px: 0.8, py: '1px',
        borderRadius: '10px',
        background: selected ? T.blue : 'rgba(255,255,255,0.05)',
        border: `1px solid ${selected ? T.blue : T.border}`,
      }}>
        <Typography sx={{ fontSize: '0.58rem', color: selected ? 'white' : T.textMuted, fontWeight: 600 }}>
          {slotCount}
        </Typography>
      </Box>
    </Box>
  );
}

function TimeChip({ time, selected, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        px: 2, py: 1,
        borderRadius: '10px',
        cursor: 'pointer',
        border: `1px solid ${selected ? T.green : T.border}`,
        background: selected ? T.greenDim : 'rgba(255,255,255,0.025)',
        boxShadow: selected ? `0 0 0 1px ${T.greenBorder}, 0 4px 12px ${T.greenDim}` : 'none',
        transition: 'all 0.16s ease',
        '&:hover': {
          border: `1px solid ${T.greenBorder}`,
          background: T.greenDim,
          transform: 'translateY(-1px)',
        },
        '&:active': { transform: 'scale(0.97)' },
      }}
    >
      <Typography sx={{
        fontSize: '0.8rem', fontWeight: 600,
        color: selected ? T.green : T.text,
      }}>
        {fmtTime(time)}
      </Typography>
    </Box>
  );
}

// ─── Main component ───────────────────────────────────────────────────────────
export default function BookingModal({ open, onClose, expert, onBookSuccess }) {
  // const [appointmentType, setAppointmentType] = useState('30min');
  const [selectedDate, setSelectedDate] = useState(null);
  const [timeSlot, setTimeSlot] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);

  const basePrice = expert?.consultation_fee || 500;
  // const appointmentTypes = [
  //   { id: 1, value: '30min', label: '30 min', duration: 30,  price: basePrice / 2 },
  //   { id: 2, value: '1hr',   label: '1 hr',   duration: 60,  price: basePrice },
  //   { id: 3, value: '1.5hr', label: '1.5 hr', duration: 90,  price: basePrice * 1.5 },
  //   { id: 4, value: '2hr',   label: '2 hr',   duration: 120, price: basePrice * 2 },
  // ];
  const [appointmentType, setAppointmentType] = useState(null);
  const [appointmentTypes, setAppointmentTypes] = useState([]);

  // 🔧 fetch + map backend data
  useEffect(() => {
    if (!expert) return;

    const fetchTypes = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;

        const res = await fetch(
          `${API_URL}/appointment-types/${expert.id}/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        const data = await res.json();

        // ✅ FIX: map backend → frontend format
        const formatted = data.types.map(t => ({
          id: t.id,
          label: t.name,        // 🔥 important fix
          duration: t.duration,
          price: t.price
        }));
        formatted.sort((a, b) => a.duration - b.duration);

        setAppointmentTypes(formatted);
        console.log(formatted);

      } catch (err) {
        console.error("Failed to load appointment types", err);
      }
    };

    fetchTypes();
  }, [expert]);
  const safeExpert = expert || { name: 'Expert', title: 'Senior Developer', expertise: ['Python/ML'] };
// AFTER
const selectedType =
  appointmentTypes.find(t => t.id === appointmentType) ||
  appointmentTypes[0] ||
  { label: '—', price: 0, duration: 0, id: null };



  // Reset on open
  useEffect(() => {
    if (open && expert) {
      setAppointmentType(null);
      setTimeSlot('');
      setNotes('');
      setSelectedDate(null);
    }
  }, [open, expert]);

  // Fetch all slots once when modal opens
  useEffect(() => {
    if (!expert || !open) return;
    const fetchSlots = async () => {
      try {
        setSlotsLoading(true);
        const API_URL = process.env.REACT_APP_API_URL;
              console.log("Fetching slots for expert.id:", expert.id);

        const res = await fetch(`${API_URL}/experts/${expert.id}/available-slots/`);
        const data = await res.json();
        setAvailableSlots(data);
      } catch (err) {
        console.error('Failed to load slots', err);
      } finally {
        setSlotsLoading(false);
      }
    };
    fetchSlots();
  }, [expert, open]);

  // Group slots by date
  const slotsByDate = useMemo(() => {
    const map = {};
    availableSlots.forEach(slot => {
      if (!map[slot.date]) map[slot.date] = [];
      map[slot.date].push(slot.start_time);
    });
    return map;
  }, [availableSlots]);

  const availableDates = useMemo(() => Object.keys(slotsByDate).sort(), [slotsByDate]);

  // Auto-select first available date
  useEffect(() => {
    if (availableDates.length > 0 && !selectedDate) {
      setSelectedDate(availableDates[0]);
      setTimeSlot('');
    }
  }, [availableDates]);

  // Reset time slot when date changes
  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setTimeSlot('');
  };
  const navigate = useNavigate();
  const timeSlotsForDate = selectedDate ? (slotsByDate[selectedDate] || []) : [];

  // ── Payment / booking logic — UNCHANGED ──────────────────────────────────
  // const handleBook = async () => {
  //   if (!timeSlot) return;
  //   try {
  //     setLoading(true);
  //     const API_URL = process.env.REACT_APP_API_URL;

  //     const response = await fetch(`${API_URL}/create-order/`, {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         expert_id:           safeExpert.id,
  //         appointment_type_id: selectedType.id,
  //         date:                selectedDate,
  //         time:                timeSlot,
  //         amount:              selectedType.price,
  //         notes:               notes,
  //       }),
  //     });

  //     if (!response.ok) {
  //       const text = await response.text();
  //       throw new Error(`Server error ${response.status}: ${text}`);
  //     }

  //     const orderData = await response.json();
  //     if (!orderData.order_id) throw new Error('Order creation failed');

  //     const loadRazorpay = () => new Promise((resolve) => {
  //       if (window.Razorpay) return resolve();
  //       const script = document.createElement('script');
  //       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
  //       script.onload = resolve;
  //       document.body.appendChild(script);
  //     });

  //     await loadRazorpay();

  //     const options = {
  //       key:         orderData.key,
  //       amount:      orderData.amount,
  //       currency:    orderData.currency,
  //       order_id:    orderData.order_id,
  //       name:        'Expert Booking',
  //       description: `Session with ${safeExpert.name}`,
  //       handler: async (razorpayResponse) => {
  //         const verifyRes = await fetch(`${API_URL}/verify-payment/`, {
  //           method: 'POST',
  //           headers: {
  //             'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify({
  //             razorpay_payment_id: razorpayResponse.razorpay_payment_id,
  //             razorpay_order_id:   razorpayResponse.razorpay_order_id,
  //             razorpay_signature:  razorpayResponse.razorpay_signature,
  //             booking_id:          orderData.booking_id,
  //           }),
  //         });

  //         if (!verifyRes.ok) throw new Error('Payment verification failed');
  //         const result = await verifyRes.json();
  //         if (result.success) {
  //           onBookSuccess && onBookSuccess(result);
  //           onClose();
  //         }
  //       },
  //       theme: { color: T.blue },
  //     };

  //     const rzp = new window.Razorpay(options);
  //     rzp.open();

  //   } catch (error) {
  //     alert('Booking failed: ' + error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleBook = () => {
    if (!timeSlot) return;

    navigate('/session-checkout', {
      state: {
        expert: safeExpert, // ✅ important (not raw expert)
        date: selectedDate,
        time: timeSlot,
        duration: selectedType?.duration,
        price: selectedType?.price,
        appointmentTypeId: selectedType?.id,
        notes: notes
      }
    });
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '96%', sm: '82%', md: 580 },
        maxHeight: '92vh',
        overflowY: 'auto',
        borderRadius: '24px',
        background: T.surface,
        border: `1px solid ${T.border}`,
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        boxShadow: '0 32px 80px rgba(0,0,0,0.7), 0 0 0 1px rgba(43,140,255,0.08)',
        outline: 'none',
        '&::-webkit-scrollbar': { width: '4px' },
        '&::-webkit-scrollbar-thumb': { background: 'rgba(43,140,255,0.2)', borderRadius: '2px' },
      }}>

        {/* ── Header ── */}
        <Box sx={{
          px: { xs: 2.5, sm: 3.5 },
          pt: { xs: 2.5, sm: 3 },
          pb: 2,
          borderBottom: `1px solid ${T.border}`,
          background: 'linear-gradient(180deg, rgba(43,140,255,0.06) 0%, transparent 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <Box>
            <Typography sx={{
              fontWeight: 700, fontSize: { xs: '1rem', sm: '1.1rem' },
              background: 'linear-gradient(90deg, #dde4f0, #6ea8ff)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }}>
              Book a Session
            </Typography>
            <Typography sx={{ color: '#7f8db3', fontSize: '0.75rem', mt: '2px' }}>
              with {safeExpert.name}
            </Typography>
          </Box>

          <Box
            onClick={onClose}
            sx={{
              width: 32, height: 32, borderRadius: '10px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'rgba(255,255,255,0.04)', border: `1px solid ${T.border}`,
              cursor: 'pointer',
              '&:hover': { background: 'rgba(255,255,255,0.08)' },
            }}
          >
            <CloseIcon sx={{ fontSize: 16, color: T.textSub }} />
          </Box>
        </Box>

        {/* ── Body ── */}
        <Box sx={{ px: { xs: 2.5, sm: 3.5 }, py: { xs: 2.5, sm: 3 } }}>

          {/* Expert info strip */}
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1.5,
            p: 2, mb: 3,
            borderRadius: '16px',
            background: T.card,
            border: `1px solid ${T.border}`,
          }}>
            <Avatar
              src={safeExpert.image || undefined}
              sx={{
                width: 44, height: 44,
                background: 'linear-gradient(135deg, #0d2145, #1a3a6e)',
                color: '#6ea8ff', fontWeight: 700, fontSize: '1rem',
                border: `1.5px solid ${T.blueBorder}`,
              }}
            >
              {!safeExpert.image && safeExpert.name?.charAt(0).toUpperCase()}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 600, color: T.text, fontSize: '0.9rem', lineHeight: 1.3 }}>
                {safeExpert.name}
              </Typography>
              <Typography sx={{ color: '#4da3ff', fontSize: '0.72rem' }}>
                {safeExpert.title}
              </Typography>
            </Box>
          </Box>

          {/* ── Appointment type ── */}
          <Box sx={{ mb: 3 }}>
            <SectionLabel icon={<AccessTimeIcon />}>Session Duration</SectionLabel>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {[...appointmentTypes]
  .sort((a, b) => a.duration - b.duration)   // ✅ sort by minutes
  .map(type => {
                const active = appointmentType === type.id;
                return (
                  <Box
                    key={type.id}
                    onClick={() => setAppointmentType(type.id)}
                    sx={{
                      px: 1.8, py: 1,
                      borderRadius: '12px',
                      cursor: 'pointer',
                      border: `1px solid ${active ? T.blue : T.border}`,
                      background: active ? T.blueDim : 'rgba(255,255,255,0.025)',
                      boxShadow: active ? `0 0 0 1px ${T.blueBorder}` : 'none',
                      transition: 'all 0.16s ease',
                      '&:hover': { border: `1px solid ${T.blueBorder}`, background: T.blueDim },
                    }}
                  >
                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: active ? T.blue : '#c5cde5' }}>
                      {type.label}
                    </Typography>
                    <Typography sx={{ fontSize: '0.68rem', color: active ? '#6ea8ff' : '#7f8db3', mt: '1px' }}>
                      ₹{type.price}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>

          {/* ── Date selection ── */}
          <Box sx={{ mb: 3 }}>
            <SectionLabel icon={<CalendarMonthIcon />}>Select Date</SectionLabel>

            {slotsLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 2 }}>
                <CircularProgress size={18} sx={{ color: T.blue }} />
                <Typography sx={{ color: T.textMuted, fontSize: '0.8rem' }}>Loading availability…</Typography>
              </Box>
            ) : availableDates.length === 0 ? (
              <Box sx={{
                py: 2.5, borderRadius: '14px', textAlign: 'center',
                background: 'rgba(255,255,255,0.02)', border: `1px solid ${T.border}`,
              }}>
                <Typography sx={{ color: T.textMuted, fontSize: '0.82rem' }}>No available dates</Typography>
              </Box>
            ) : (
              <Box sx={{
                display: 'flex', gap: 1, flexWrap: 'nowrap',
                overflowX: 'auto', pb: 0.5,
                '&::-webkit-scrollbar': { height: '3px' },
                '&::-webkit-scrollbar-thumb': { background: 'rgba(43,140,255,0.2)', borderRadius: '2px' },
              }}>
                {availableDates.map(date => (
                  <DateChip
                    key={date}
                    date={date}
                    selected={selectedDate === date}
                    onClick={() => handleDateSelect(date)}
                    slotCount={slotsByDate[date]?.length || 0}
                  />
                ))}
              </Box>
            )}
          </Box>

          {/* ── Time slots ── */}
          <Box sx={{ mb: 3 }}>
            <SectionLabel icon={<AccessTimeIcon />}>Select Time</SectionLabel>

            {!selectedDate ? (
              <Typography sx={{ color: T.textMuted, fontSize: '0.8rem' }}>Pick a date first</Typography>
            ) : timeSlotsForDate.length === 0 ? (
              <Typography sx={{ color: T.textMuted, fontSize: '0.8rem' }}>No slots for this date</Typography>
            ) : (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {timeSlotsForDate.map(slot => (
                  <TimeChip
                    key={slot}
                    time={slot}
                    selected={timeSlot === slot}
                    onClick={() => setTimeSlot(slot)}
                  />
                ))}
              </Box>
            )}
          </Box>

          {/* ── Notes ── */}
          <Box sx={{ mb: 3 }}>
            <TextField
              label="Notes (optional)"
              multiline rows={2}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '14px',
                  background: 'rgba(255,255,255,0.025)',
                  color: T.text, fontSize: '0.88rem',
                  '& fieldset': { borderColor: T.border },
                  '&:hover fieldset': { borderColor: T.blueBorder },
                  '&.Mui-focused fieldset': { borderColor: T.blue },
                },
                '& .MuiInputLabel-root': { color: T.textMuted, fontSize: '0.85rem' },
                '& .MuiInputLabel-root.Mui-focused': { color: T.blue },
                '& textarea': { color: T.text },
              }}
            />
          </Box>

          {/* ── Summary + CTA ── */}
          <Box sx={{
            p: 2, mb: 2.5,
            borderRadius: '16px',
            background: T.card,
            border: `1px solid ${T.border}`,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            gap: 1,
          }}>
            <Box>
              <Typography sx={{ fontSize: '0.72rem', color: T.textMuted }}>Selected</Typography>
              <Typography sx={{ fontSize: '0.85rem', color: T.text, fontWeight: 600, mt: '2px' }}>
                {selectedDate ? `${dayjs(selectedDate).format('D MMM')}` : '—'}
                {timeSlot ? ` · ${fmtTime(timeSlot)}` : ''}
                {` · ${selectedType.label}`}
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
              <Typography sx={{ fontSize: '0.68rem', color: T.textMuted }}>Total</Typography>
              <Typography sx={{ fontSize: '1.15rem', fontWeight: 700, color: T.green }}>
                ₹{selectedType.price}
              </Typography>
            </Box>
          </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: 1.5, flexDirection: { xs: 'column', sm: 'row' } }}>
            <Button
              fullWidth variant="outlined" onClick={onClose}
              sx={{
                borderRadius: '12px', py: 1.2,
                fontSize: '0.85rem', fontWeight: 600, textTransform: 'none',
                color: T.textSub, borderColor: T.border,
                '&:hover': { borderColor: T.blueBorder, background: T.blueDim, color: T.text },
              }}
            >
              Cancel
            </Button>

            <Button
              fullWidth variant="contained"
              onClick={handleBook}
              disabled={!timeSlot || loading}
              startIcon={loading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : null}
              sx={{
                borderRadius: '12px', py: 1.2,
                fontSize: '0.85rem', fontWeight: 600, textTransform: 'none',
                background: 'linear-gradient(90deg, #00b85a, #00e676)',
                boxShadow: '0 4px 18px rgba(0,230,118,0.25)',
                color: '#001a0d',
                transition: 'all 0.22s ease',
                '&:hover': {
                  background: 'linear-gradient(90deg, #00cc66, #00ff88)',
                  boxShadow: '0 6px 26px rgba(0,230,118,0.38)',
                  transform: 'translateY(-1px)',
                },
                '&:active': { transform: 'scale(0.98)' },
                '&:disabled': { background: 'rgba(0,230,118,0.1)', color: T.textMuted, boxShadow: 'none' },
              }}
            >
              {loading ? 'Processing…' : 'Confirm & Pay'}
            </Button>
          </Box>

        </Box>
      </Box>
    </Modal>
  );
}